import React from 'react'
import InlineSvg from './InlineSvg'
import { t } from '../utils/i18n'
import { formatCurrency } from '../utils/money'
import { addToCartClicked, getQuoteClicked } from '../actions'
import { useDispatch } from 'react-redux'
import { BaseModelId, CurrencyCode } from 'shared'

interface BuyButtonProps {
  baseModelId: BaseModelId
  currencyCode: CurrencyCode
  totalPrice: number
}

const BuyButton: React.FC<BuyButtonProps> = ({
  baseModelId,
  currencyCode,
  totalPrice
}) => {
  const dispatch = useDispatch()
  const isCargo: boolean = baseModelId.includes('cargo')

  const handleAddToCartClick = () => {
    dispatch(addToCartClicked())
  }

  const handleGetQuoteClick = () => {
    dispatch(getQuoteClicked())
  }

  return (
    <div
      className="velorbis-customizer-header-tool velorbis-customizer-flex-1 velorbis-customizer-header-add-to-cart"
      onClick={isCargo ? handleGetQuoteClick : handleAddToCartClick}
    >
      <div className="velorbis-customizer-header-tool-inner">
        <InlineSvg src="icons/cart" />
        <div className="velorbis-customizer-hidden-md-down">
          {isCargo ? '' : t('add_to_cart_button')}
        </div>
        <div className="velorbis-customizer-header-tool-text">
          {isCargo ? t('get_quote') : formatCurrency(totalPrice, currencyCode)}
        </div>
      </div>
    </div>
  )
}

export default BuyButton
